import { render, staticRenderFns } from "./crm-update_patientHistoryType.vue?vue&type=template&id=5bb713aa&"
import script from "./crm-update_patientHistoryType.vue?vue&type=script&lang=js&"
export * from "./crm-update_patientHistoryType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports